import React, { useRef,useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Auctioneers = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [auctioneersData, setAuctioneers] = useState([]);
    const [auctioneerId, setAuctioneerId] = useState(0);
    const [roleId, setRoleId] = useState(0);
    const [userName, setUserName] = useState('');
    const [companyId, setCompanyId] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [userCode, setUserCode] = useState('');
    const [useMobileNoAsPassword, setUseMobileNoAsPassword] = useState(true);
    const [password, setPassword] = useState('');
    const [isPasswordChanged, setIsPasswordChanged] = useState(false);
    const api = useApi();
    const gridRef = useRef();

    const loadCompanies = async () => {
        try {
            const _companies = await api.getCompanies();
            setCompanies(_companies);
        } catch (error) {
            alert('Unable to fetch companies.');
        }
    }

    const loadAuctioneers = async () => {
        await api.getAuctioneers().then((data) => {
            setAuctioneers(data);
        })
    }

    useEffect(() => {
        loadAuctioneers();
    }, []);

    const addNewAuctioneer = () => {
        loadCompanies();
        setAuctioneerId(0);
        setCompanyId(null);
        setRoleId(null);
        setUserName(null);
        setPhoneNumber(null);
        setEmail(null);
        setUserCode(null);
        setPassword(null);
        setIsPasswordChanged(false);
        setUseMobileNoAsPassword(true);
        setModalVisible(true);
    }

    const editAuctioneer = (auc) => {
        loadCompanies();
        setAuctioneerId(auc.auctioneerId);
        setCompanyId(auc.companyId);
        setRoleId(auc.roleId);
        setUserName(auc.userName);
        setPhoneNumber(auc.phoneNumber);
        setEmail(auc.email);
        setUserCode(auc.userCode);
        setUseMobileNoAsPassword(auc.useMobileNoAsPassword);
        setIsPasswordChanged(false);
        if (auc.useMobileNoAsPassword)
            setPassword(auc.phoneNumber);
        else
            setPassword(null);
        setModalVisible(true);
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    const handleCompanyIdChange = (event) => {
        setCompanyId(event.target.value);
    };
    const handleRoleChange = (event) => {
        setRoleId(event.target.value);
    };
    const handleUserNameChange = (event) => {
        setUserName(event.target.value);
    };
    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
    };
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };
    const handleUserCodeChange = (event) => {
        setUserCode(event.target.value);
    };
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setIsPasswordChanged(true);
    };
   
    const handleCheckboxChange = (event) => {
        setUseMobileNoAsPassword(event.target.checked);
        if (event.target.checked)
            setPassword(phoneNumber);
    };
    const onSaveAuctioneer = async () => {
        const params = {
            auctioneerId,
            companyId,
            roleId,
            userName,
            phoneNumber,
            email,
            userCode,
            useMobileNoAsPassword,
            password,
            isPasswordChanged,
        };

        await api.saveAuctioneer(params).then((data) => {
            loadAuctioneers();
            setModalVisible(false);
        }).catch((error) => {
            console.error('Error saving auctioneer:', error);
        });
    };


    const linkRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => editAuctioneer(props.data)}>{cellValue}</span>
            </span>
        );
    };



    const columns = [
        { headerName: 'User Code', field: 'userCode', headerClass: 'text-center', cellClass: 'text-center', width: 80 },
        { headerName: 'Role', field: 'roleName', width: 160 },
        { headerName: 'Auctioneer Name', field: 'userName', cellRenderer: linkRenderer, width: 250 },
        { headerName: 'Company Name', field: 'companyName', width: 250 },
        { headerName: 'Mobile Number', field: 'phoneNumber', headerClass: 'text-center', cellClass: 'text-center', width: 100 },
        { headerName: 'Email Id', field: 'email', width: 260 },
      
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            document.getElementById("filter-text-box").value,
        );
    }, []);

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Auctioneers</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Auctioneers</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        <button type="button" className="btn btn-primary my-2 btn-icon-text" onClick={addNewAuctioneer}>
                            <i className="fe fe-edit me-2"></i> Add New Auctioneer
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>

                                </div>
                                <div>
                                    <input type="text" className="form-control" id="filter-text-box" onChange={onFilterTextBoxChanged} placeholder="type to filter"></input>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={"ag-theme-alpine"}
                            >
                                <AgGridReact
                                    ref={gridRef}
                                    gridOptions={gridOptions}
                                    rowData={auctioneersData}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Modal backdrop="static" show={modalVisible} size='lg'  onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add/Edit Auctioneer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        Auctioneer
                        <select
                            className="form-control select2-show-search select2-dropdown select2-hidden-accessible"
                            tabIndex="-1"
                            aria-hidden="true"
                            value={companyId}
                            onChange={handleCompanyIdChange}
                        >
                            <option label="Choose one"></option>
                            {companies?.map(t => {
                                return <option value={t.companyId}>{t.companyName}</option>
                            })}
                        </select>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                Name
                                <input className="form-control" placeholder="User Name" type="text" value={userName}
                                    onChange={handleUserNameChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                Role
                                <select
                                    className="form-control select2-show-search select2-dropdown select2-hidden-accessible"
                                    tabIndex="-1"
                                    aria-hidden="true"
                                    value={roleId}
                                    onChange={handleRoleChange}
                                >
                                    <option label="Choose one"></option>
                                    <option value="2">Primary Auctioneer</option>
                                    <option value="3">Secondary Auctioneer</option>
                                    <option value="4">Support Auctioneer</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                Mobile Number
                                <input className="form-control" placeholder="Mobile Number" type="text" value={phoneNumber}
                                    onChange={handlePhoneNumberChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                Email Id
                                <input className="form-control" placeholder="Email" type="text" value={email}
                                    onChange={handleEmailChange} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                User Code
                                <input className="form-control" placeholder="User Code" type="text" value={userCode}
                                    onChange={handleUserCodeChange} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <div><span>Password</span>
                                    <label class="custom-switch float-end mb-0">
                                        <a href="" class="tx-14 mg-t-4 mb-0 me-2 text-dark"> <small> Use mobile number as password</small></a> <input type="checkbox" name="custom-switch-checkbox med-height" class="custom-switch-input" onChange={handleCheckboxChange} checked={useMobileNoAsPassword} /> <span class="custom-switch-indicator"></span>
                                    </label>
                                </div>
                                <input className="form-control" placeholder="Password" type="password" disabled={useMobileNoAsPassword} value={password}
                                    onChange={handlePasswordChange} />

                            </div>
                        </div>
                    </div>
                  
                    
                    <div className="mg-t-10">
                        <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onSaveAuctioneer}>
                            Save
                        </button>
                        <button className="btn ripple btn-light pd-x-30" onClick={handleClose}>
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Auctioneers;



